// services/productService.js
import api from './api';
import { API_ENDPOINTS, processProductImages, processProductsArray } from '../utils/constants';

export const productService = {
  // Get all products
  getAll: async (params = {}) => {
    try {
      const response = await api.get(API_ENDPOINTS.PRODUCTS, { params });
      return processProductsArray(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  },

  // Get single product
  getById: async (id) => {
    try {
      const response = await api.get(API_ENDPOINTS.PRODUCT_DETAIL(id));
      return processProductImages(response.data);
    } catch (error) {
      console.error(`Error fetching product ${id}:`, error);
      throw error;
    }
  },

  // Create product
  create: async (formData) => {
    try {
      const response = await api.post(API_ENDPOINTS.PRODUCTS, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return processProductImages(response.data);
    } catch (error) {
      console.error('Error creating product:', error);
      throw error;
    }
  },

  // Update product
  update: async (id, formData) => {
    try {
      const response = await api.put(API_ENDPOINTS.PRODUCT_DETAIL(id), formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return processProductImages(response.data);
    } catch (error) {
      console.error(`Error updating product ${id}:`, error);
      throw error;
    }
  },

  // Delete product
  delete: async (id) => {
    try {
      const response = await api.delete(API_ENDPOINTS.PRODUCT_DETAIL(id));
      return response.data;
    } catch (error) {
      console.error(`Error deleting product ${id}:`, error);
      throw error;
    }
  },

  // Delete product image
  deleteImage: async (productId, imageId) => {
    try {
      const response = await api.delete(API_ENDPOINTS.DELETE_IMAGE(imageId));
      console.log(`Image ${imageId} deleted successfully`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting image ${imageId}:`, error);
      throw error;
    }
  },
};